export default __webpack_public_path__ + "static/media/purchased-white.275929b5.svg";